
// Refactored Question Renderer - now uses individual question type components
import EmergencyQuestion from "./question-types/EmergencyQuestion";
import CategoryDropdownQuestion from "./question-types/CategoryDropdownQuestion";
import SingleChoiceQuestion from "./question-types/SingleChoiceQuestion";
import MultipleChoiceQuestion from "./question-types/MultipleChoiceQuestion";
import ScaleQuestion from "./question-types/ScaleQuestion";
import CircularScaleQuestion from "./question-types/CircularScaleQuestion";
import { Question } from "@/data/assessmentQuestions";

interface QuestionRendererProps {
  question: Question;
  currentAnswer: any;
  onAnswer: (answer: string | string[] | any) => void;
}

const QuestionRenderer = ({ question, currentAnswer, onAnswer }: QuestionRendererProps) => {
  switch (question.type) {
    case "single":
      return (
        <SingleChoiceQuestion
          options={(question.options as string[]) || []}
          currentAnswer={currentAnswer}
          onAnswer={onAnswer}
          allowOther={question.allowOther}
        />
      );
    case "multiple":
      return (
        <MultipleChoiceQuestion
          options={(question.options as string[]) || []}
          currentAnswer={currentAnswer || []}
          onAnswer={onAnswer}
          allowOther={question.allowOther}
        />
      );
    case "scale":
      // Use circular dial for daily impact question (question 6)
      if (question.id === "daily_impact") {
        return (
          <CircularScaleQuestion
            options={(question.options as string[]) || []}
            currentAnswer={currentAnswer}
            onAnswer={onAnswer}
          />
        );
      }
      return (
        <ScaleQuestion
          options={(question.options as string[]) || []}
          currentAnswer={currentAnswer}
          onAnswer={onAnswer}
        />
      );
    case "emergency":
      return (
        <EmergencyQuestion
          options={question.options || []}
          currentAnswer={currentAnswer}
          onAnswer={onAnswer}
          emergencyNote={question.emergencyNote}
        />
      );
    case "category-dropdown":
      return (
        <CategoryDropdownQuestion
          categories={question.categories || {}}
          currentAnswer={currentAnswer}
          onAnswer={onAnswer}
        />
      );
    default:
      return null;
  }
};

export default QuestionRenderer;
